import { Box, Button, Divider, HStack, VStack } from "@chakra-ui/react";
import { useAppContext } from "./hooks";
import React from "react";
import { signOut } from "./api";
import { useNavigate } from "react-router-dom";

import { ParticleBasketball } from "./ParticleBasketball";

export const NavBar = () => {
  const { user, setUser } = useAppContext();
  const navigate = useNavigate();

  const onSignOut = React.useCallback(async () => {
    await signOut();
    setUser(null);
  }, []);

  return (
    <VStack w="100%">
      <HStack w="100%" p={3} justifyContent={"space-between"} flexDir="row">
        {
          <div
            onClick={() => window.open("https://www.balldontlie.io")}
            style={{ cursor: "pointer" }}
          >
            <ParticleBasketball height={80} width={96} quality="compact" />
          </div>
        }
        <Box>
          <Button
            colorScheme="brand"
            variant="outline"
            mr={4}
            onClick={() => window.open("https://www.balldontlie.io/docs")}
          >
            View Docs
          </Button>
          {user?.email ? (
            <Button onClick={onSignOut}>Log Out</Button>
          ) : (
            <>
              <Button
                colorScheme="brand"
                mr={4}
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </Button>
              <Button variant="outline" onClick={() => navigate("/signin")}>
                Sign In
              </Button>
            </>
          )}
        </Box>
      </HStack>
      <Divider />
    </VStack>
  );
};
